import {
  CollectionActions,
  CollectionStateSlice,
  deepSpread,
  mapValues,
  mergeDocuments,
  transformIntoDocuments,
  updateWebsocketDocuments,
} from '@freelancer/datastore/core';
import { toNumber } from '@freelancer/utils';
import { transformPreferredBillingAgreement } from './preferred-billing-agreements.transformers';
import { PreferredBillingAgreementsCollection } from './preferred-billing-agreements.types';

export function preferredBillingAgreementsReducer(
  state: CollectionStateSlice<PreferredBillingAgreementsCollection> = {},
  action: CollectionActions<PreferredBillingAgreementsCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'preferredBillingAgreements') {
        const { result, order, ref } = action.payload;
        const preferredPaymentMethods = mapValues(
          result.preferred_payment_source || {},
          (billingAgreement, bidId) => ({
            bid_id: toNumber(bidId),
            payment_source: billingAgreement,
          }),
        );
        return mergeDocuments<PreferredBillingAgreementsCollection>(
          state,
          transformIntoDocuments(
            preferredPaymentMethods,
            transformPreferredBillingAgreement,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'preferredBillingAgreements') {
        const { delta, originalDocument, ref } = action.payload;
        return updateWebsocketDocuments<PreferredBillingAgreementsCollection>(
          state,
          [originalDocument.id],
          preferredBillingAgreement =>
            deepSpread(preferredBillingAgreement, delta),
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
